export default __webpack_public_path__ + "img/Khourys-Rewards.png";